import { Fragment, FunctionalComponent, h } from 'preact';
import { connectWithStyles } from '../../../../../store';
import * as styles from '../Item/Item.scss';
import * as appStyles from '../../../../../assets/global.scss';
import { WithStyles } from '../../../../../style';
import { MonthPrice, NBSP } from '../../../../../common';
import { DateFormat, DateText, PriceFormat, PriceFormatOptions } from '../../../../../i18n';
import Icon from '../../../../../common/Icon/Icon';

export interface ItemProps {
  monthData: MonthPrice;
  selectMonth: (key: number) => void;
  monthId: number;
  height: string;
  isSelected: boolean;
  minHeight: string;
}

export type EffectiveProps = ItemProps & WithStyles;

const priceFormatOptions: PriceFormatOptions = Object.freeze({
  abbreviate: true,
  showThousandSeparators: false,
  showSymbol: true,
  placeholder: NBSP,
  trimWhitespace: true,
  useCalendarOptions: true,
});

export const Item: FunctionalComponent<ItemProps> = connectWithStyles<ItemProps>(
  [styles, appStyles],
  {}
)(({ tx, monthData, selectMonth, monthId, height, isSelected, minHeight }: EffectiveProps) => {
  const onMonthClick = (monthId: number): void => {
    if (!isSelected) {
      selectMonth(monthId);
    }
  };

  return (
    <Fragment>
      {monthData.isSeparator && (
        <div className={tx('flex flex--center flex--column')}>
          <p className={tx('font-body-1')}>{monthData.date.split('-')[0]}</p>
          <p className={tx('border-left grow')} />
        </div>
      )}

      <div
        className={tx(
          'histogram-item shadow-small flex flex--column-reverse border-top border-right border-left rounded-top-medium flex--self-end link-hover',
          {
            isCheapest: monthData.isCheapest,
            selected: isSelected,
            noFlight: monthData.noFlight,
          }
        )}
        style={{ height, minHeight }}
        onClick={() => onMonthClick(monthId)}
      >
        {!monthData.noFlight ? (
          <p className={tx('text-align center font-body-2 medium-type')}>
            <PriceFormat price={monthData.price} options={priceFormatOptions} />
          </p>
        ) : (
          <div class={tx('center flex ms-xxsmall-b')}>
            <Icon
              // @todo Add aria-label with translation
              aria-label="flights-unavailable"
              iconName="flights-unavailable"
              class={tx('is-xxsmall icon ps-small-l nordic-blue-900-text')}
            />
          </div>
        )}
        <p className={tx('date text-align center font-body-2')}>
          <DateText value={monthData.date} format={DateFormat.MONTH_SHORT} />
        </p>
      </div>
    </Fragment>
  );
});
